import { Box } from '@mui/system';
import { ReactElement } from 'react';
import { styles } from './logo.styles';
import xdosLogo from '../../assets/img/xdos-logo.jpg';

const Logo = (): ReactElement => {
  return (
    <Box sx={styles.mainBox}>
      <Box component="img" src={xdosLogo} alt="XDOS" sx={styles.image} />
      <Box sx={styles.wordmark} aria-hidden="true">
        <Box sx={styles.textAccent}>X</Box>
        <Box sx={styles.text}>
          DOS
          <sup>&reg;</sup>
        </Box>
      </Box>
    </Box>
  );
};

export default Logo;
